export function hexToRgb(hex: string): number[] {
    hex = hex.replace(/^#/, '');
    let bigint = parseInt(hex, 16);
    if (hex.length === 3) {
      return [
        ((bigint >> 8) & 0xf) * 17,
        ((bigint >> 4) & 0xf) * 17,
        (bigint & 0xf) * 17
      ];
    }
    return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
  }
  
  export function getLuminance(hex: string): number {
    const [r, g, b] = hexToRgb(hex).map(c => {
      let channel = c / 255;
      return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b; // Luminance formula
  }
  
  export function isLightColor(hex: string): boolean {
    return getLuminance(hex) > 0.5; // Threshold to determine light vs. dark
  }
  